import { API_URL } from "../../../../../../constants";
import * as httpNetworking from "../../../../../../httpNetworking";
import { ApiKeyResponse } from "../../../../deployment/apiKey/post";

const VERSION = 0;

export async function addNewApiKeyForMultiTenantApp(data: {
    deploymentId: string;
    deploymentType: "production" | "development";
    appId: string;
}): Promise<ApiKeyResponse> {
    const { deploymentId, appId, deploymentType } = data;

    const options: httpNetworking.GETRequestConfig = {};

    const url = `${API_URL}/saas/multi-tenancy/connection-uri-domain/${appId}/apikey`;

    let response = await httpNetworking.simplePOSTRequest(
        url,
        {
            deploymentId,
            deploymentType
        },
        options,
        VERSION
    );
    return response.data as ApiKeyResponse;
}
